import { type IconData } from '../types';
import DataStoreRecordBehaviors from '../collaboration/DataStoreRecordBehaviors';
import { type RenderedDimensions } from '@lib/canvasx/components/FlexRow';
import { type SortableItem } from '../models/ItemCollection';

export interface WireframeItemData extends SortableItem {
  state: string;
  value: string;
  iconLeft: IconData;
  iconRight: IconData;
  dimensions: RenderedDimensions;
  // For list-like components (e.g., tabs, multiselect), each item is wrapped
  // in an additional container
  containerDimensions: RenderedDimensions | DimensionStruct;
}

interface WireframeItem extends WireframeItemData {}

export const isWireframeItem = (item: any): item is WireframeItem => {
  return item instanceof WireframeItem;
};

class WireframeItem extends DataStoreRecordBehaviors(Object) {
  serializedKeys = ['id', 'index', 'state', 'value', 'iconLeft', 'iconRight'];

  constructor(values: Partial<WireframeItemData>) {
    super();

    Object.assign(this, values);
  }
}

export default WireframeItem;
